import {
  InputTextArea,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import {
  defaultToastSuccess,
  defaultToastError,
  formatRupiah,
  convertToValidPrice,
} from "App/utils/helpers";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants";
import { STATE_TAMBAH_PAKET, urlTambahPaket } from "./helpers";

const ModalTambahPaket = ({ setShowModal, handleGetList, formPaket, setFormPaket, reloadTagihan }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const api = await instance3.post(urlTambahPaket, {
        id_tagihan: formPaket.id_tagihan,
        id_mh_paket: formPaket.id_mh_paket,
        id_paket: formPaket.id_paket,
        harga_awal: convertToValidPrice(formPaket.harga_awal),
        harga: convertToValidPrice(formPaket.harga),
        nama_paket: formPaket.nama_paket,
        remark: formPaket.remark,
      });
      const res = await api?.data;
      if (res.status === 200) {
        reloadTagihan();
        setFormPaket(STATE_TAMBAH_PAKET);
        setShowModal(false);
        defaultToastSuccess(res?.message);
        await handleGetList();
      } else {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(res?.message);
      }
    } catch (error) {
      console.log(error)
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={`Tambah Paket`} show={setShowModal} width="70%">
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={5}>
            <Grid container spacing={1}>
              <Grid item sm={12}>
                <InputTextMaster
                  name="id_paket"
                  label="ID PAKET"
                  id="id_paket"
                  value={formPaket.id_paket}
                  placeholder="0"
                  disabled
                />
              </Grid>
              <Grid item sm={12}>
                <InputTextMaster
                  name="nama_paket"
                  label="NAMA PAKET"
                  id="nama_paket"
                  value={formPaket.nama_paket}
                  placeholder="Nama Paket"
                  disabled = {formPaket.id_paket === 0 ? false : true}
                  onChange={(e) =>
                    setFormPaket({
                      ...formPaket,
                      nama_paket: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item sm={12}>
                <InputTextMaster
                  name="harga_asli"
                  label="HARGA ASLI"
                  id="harga_asli"
                  value={formPaket.harga_awal}
                  placeholder="0"
                  disabled
                  withButtonLeft={true}
                >
                  <button
                    type={"button"}
                    onClick={null}
                    style={{
                      borderLeft: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderRight: "0",
                      background: "#f7f7f7",
                      padding: "0 0 0 0.8rem",
                      cursor: "pointer",
                      borderRadius: "6px 0 0 6px",
                      fontSize: "10px",
                    }}
                  >
                    Rp.
                  </button>
                </InputTextMaster>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={7}>
            <Grid container spacing={1}>
              <Grid item sm={12}>
                <InputTextMaster
                  name="harga_asli"
                  label="HARGA CUSTOM"
                  id="harga_asli"
                  value={formPaket.harga}
                  onChange={(e) =>
                    setFormPaket({
                      ...formPaket,
                      harga: formatRupiah(e.target.value),
                    })
                  }
                  withButtonLeft={true}
                >
                  <button
                    type={"button"}
                    onClick={null}
                    style={{
                      borderLeft: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderRight: "0",
                      background: "#ffffff",
                      padding: "0 0 0 0.8rem",
                      cursor: "pointer",
                      borderRadius: "6px 0 0 6px",
                      fontSize: "10px",
                    }}
                  >
                    Rp.
                  </button>
                </InputTextMaster>
              </Grid>
              <Grid item sm={12}>
                <InputTextArea
                  name="remark"
                  label="KETERANGAN"
                  id="remark"
                  value={formPaket.remark}
                  onChange={(e) =>
                    setFormPaket({
                      ...formPaket,
                      remark: e.target.value,
                    })
                  }
                  rows={5}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.state}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
};

export default ModalTambahPaket;
